import { ISessionManager } from "@/domain/repositories/Session";
import { createSession, deleteSession, getSession } from "./session-next-cookies-utils";

export class SessionNextCookies implements ISessionManager {

  async createSession(authData: { token: string; refreshToken: string }) {
    return await createSession(authData);
  }

  async deleteSession() {
    return await deleteSession();
  }

  async getSession() {
    return await getSession();
  }
}
